module.exports = __webpack_public_path__ + "7326ae0e315c527b85773c4bf80f64b0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatitle/KomikaTitle-Axis-webfont.ttf
// module id = 234
// module chunks = 0